import {Pipe, PipeTransform} from '@angular/core';
import {VendorTerm} from "@services";

@Pipe({
    name: 'vendorTerm',
    standalone: true
})
export class VendorTermPipe implements PipeTransform {
    transform(value: VendorTerm | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case VendorTerm.ThirtyDays: return "30 Days";
            case VendorTerm.FortyFiveDays: return "45 Days";
            case VendorTerm.SixtyDays: return "60 Days";
            default: return value;
        }
    }
}